import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';


ReactDOM.render(
  <React.StrictMode>
    <App />
    
    <style>{'body { background-color: magenta; }'}</style>
  </React.StrictMode>,
  document.getElementById('root')
);


